<template>
  <div class="settings-overlay-container" @click.stop="">
    <div class="settings-overlay-card">
      <div class="settings-overlay-header">
        <h4 class="settings-overlay-title">Settings</h4>
        <div class="settings-overlay-exit">
          <button class="settings-overlay-logout-btn" @click="this.handleLogout">Logout</button>
          <div class="badge" @click="handleClose">
            {{ this.initials }}
          </div>
        </div>
      </div>
      <div class="settings-overlay-buttons-container">
        <div class="settings-overlay-buttons-box">
          <NUIButton id="ms-units-btn" :obj="this.units" :displayType="'icon'" :isSelected="appFunction === 'units'">
          </NUIButton>
          <NUIButton id="ms-password-btn" :obj="this.pass" :displayType="'icon'" :isSelected="appFunction === 'password'">
          </NUIButton>
          <div class="button-divider"></div>
          <NUIButton :obj="this.flush" :displayType="'show-hide'" :setting="getFlushSetting" >
          </NUIButton>
          <NUIButton :obj="this.monochrome" :displayType="'show-hide'" :setting="getMonochromeSetting"  >
          </NUIButton>
        </div>
      </div>
      <div class="settings-overlay-content">
        <Units v-if="isUnits" />
        <PassRedeem v-if="isPassRedeem" />
      </div>
    </div>
  </div>
</template>

<script>
import { useIdentityStore } from '../store/IdentityStore';
import NUIButton from '../components/nelsonUI/NUIButton.vue';
import Units from '../components/settings/Units.vue';
import PassRedeem from '../components/settings/PassRedeem.vue';
import { useModalStore } from '@/store/ModalStore';
import { useSettingsStore } from '@/store/SettingsStore';

export default {
  data () {
    return {
      isUnits: true,
      isPassRedeem: false,
      isShow: true,
      appFunction: 'units',
      units: {
        label: 'Units',
        icon: 'data',
        value: 'units',
        orientation: 'top',
        marker: 'var(--nelson-blue)',
        func: this.toggleUnitsView,
      },
      pass: {
        label: 'Password',
        icon: 'data',
        value: 'password',
        orientation: 'top',
        marker: 'var(--nelson-gray)',
        func: this.togglePassView,
      },
      flush: {
        label: 'Flush',
        icon: 'data',
        value: 'flush',
        orientation: 'top',
        marker: 'var(--nelson-gray)',
        func: this.handleHideFlush,
      },
      monochrome: {
        label: 'Monochrome',
        icon: 'data',
        value: 'monochrome',
        orientation: 'top',
        marker: 'var(--nelson-gray)',
        func: this.handleMonochrome,
      }
    };
  },
  setup () {
    useIdentityStore().getUserProperties();
  },
  components: {
    NUIButton,
    Units,
    PassRedeem,
  },
  computed: {
    getFlushSetting () {
      return useSettingsStore().IsFlush;
    },
    getMonochromeSetting () {
      return useSettingsStore().getIsMonochrome;
    },
    initials () {
      const user = useIdentityStore().User;
      return user ? user.initials : '';
    },
    IsShow () {
      return useSettingsStore().IsFlush;
    }
  },
  methods: {
    handleLogoutStyle () {
      return {
        'background-color': 'var(--nelson-blue)',
        'width': '120px',
        'float': 'right',
      };
    },
    handleClose () {
      useModalStore().hideModal();
    },
    togglePassView () {
      if (!this.isPassRedeem) {
        this.appFunction = 'password';
        this.isUnits = this.isUnits ? false : true;
        this.isPassRedeem = this.isPassRedeem ? false : true;
      }
    },
    toggleUnitsView () {
      if (!this.isUnits) {
        this.appFunction = 'units';
        this.isUnits = this.isUnits ? false : true;
        this.isPassRedeem = this.isPassRedeem ? false : true;
      }
    },
    handleLogout () {
      useIdentityStore().signout();
    },
    handleHideFlush () {
      useSettingsStore().setFlushShow(!this.IsShow);
    },
    handleMonochrome () {
      useSettingsStore().setIsMonochrome(!useSettingsStore().getIsMonochrome);
    }
  }
};
</script>

<style scoped>
.settings-overlay-title {
  margin: 0;
}
.settings-overlay-container {
  background-color: #FFFFFF;
  width: 40%;
}
.settings-overlay-card {
  width: 100%;
}
.settings-overlay-buttons-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid #E5E5E5;
  height: 65px;
  margin-bottom: 1rem;
}
.settings-overlay-content {
  padding: 0 2rem;
}
.settings-overlay-buttons-box {
  display: flex;
  flex-direction: row;
}
.settings-overlay-header {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  padding: 8px 1rem;
}
.settings-overlay-exit {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.settingsBtn {
  padding: 5px;
  margin-top: 20px;
  margin-bottom: 15px;
  margin-right: 15px;
  background-color: var(--nelson-blue);
  color: white;
}
.closeIcon {
  margin-right: 10px;
  margin-top: -65px;
  float: right;
  background-color: rgb(185, 4, 4);
  border-radius: 20px;
}
.closeIcon:hover {
  box-shadow: 2px 2px 4px #444343;
}
.progress-circle {
  padding-left: 5px;
}
.badge {
  aspect-ratio: 1/1;
  cursor: pointer;
  background-color: black;
  border-radius: 25px;
  color: white;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.settings-overlay-logout-btn {
  background-color: #FFFFFF;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  padding-right: 1rem;
}
.flush-btn-overlay {
  height: 100%;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  display: flex;
  flex: 1;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: white;
}
.flush-btn-overlay:hover {
  background-color: #F2F2F2;
}
.flush-btn-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}
.flush-btn-text {
  color: black;
  font-size: 70%;
  white-space: nowrap;
}
.flush-btn-spacer {
  width: 30px;
  height: 100%;
}
.flush-btn-eye-icon {
  width: 20px;
}
.flush-btn-bar {
  width: 100%;
  height: 5px;
  background-color: rgb(153, 153, 153);
}
.button-divider {
  width: 2px;
  height: 100%;
  background-color: gray;
  margin-left: 4px;
  margin-right: 4px;
}
</style>
